<!-- START: Gmail top bar -->
<div class="gmail-topbar d-flex align-items-center gap-3">
  <i class="bi bi-list gmail-icon"></i>

  <div class="gmail-brand d-flex align-items-center gap-2">
    <img
      class="gmail-logo"
      src="/assets/images/gmail-logo.png"
      alt="Gmail"
    />
  </div>

  <div class="gmail-search flex-grow-1 d-flex align-items-center">
    <i class="bi bi-search"></i>
    <input class="gmail-search-input placeholder" type="search" disabled />
    <i class="bi bi-sliders gmail-filter-icon"></i>
  </div>
</div>
<!-- END: Gmail top bar -->

<!-- START: Gmail tabs -->
<div class="gmail-tabs d-flex">
  <div class="gmail-tab">
    <i class="bi bi-display"></i>
    <span>Primary</span>
  </div>
  <div class="gmail-tab active">
    <i class="bi bi-tag-fill"></i>
    <span>Promotions</span>
  </div>
  <div class="gmail-tab">
    <i class="bi bi-chat-left-text"></i>
    <span>Social</span>
  </div>
</div>
<!-- END: Gmail tabs -->

<!-- START: Real ad -->
<div class="gmail-ad-row d-flex align-items-center gap-3">
  <img *ngIf="creativeImage" class="gmail-ad-thumb" [src]="creativeImage" alt="" />
  <div *ngIf="!creativeImage" class="gmail-ad-thumb creative-missing" [title]="missingDimensionLabel">{{ missingDimensionShortLabel }}</div>

  <div class="gmail-ad-body flex-grow-1">
    <div class="gmail-ad-meta">
      <span class="gmail-ad-label">Ad</span>
      <span class="gmail-ad-dot">&middot;</span>
      <span class="gmail-ad-advertiser">Valamar</span>
      <i class="bi bi-box-arrow-up-right gmail-ad-link-icon"></i>
    </div>
    <div class="gmail-ad-text">
      <span class="gmail-ad-headline">{{ data.headlines[0] }}</span>
      <span class="gmail-ad-dash"> - </span>
      <span class="gmail-ad-description">{{ data.descriptions[0] }}</span>
    </div>
  </div>

  <i class="bi bi-three-dots-vertical gmail-ad-more"></i>
</div>
<!-- END: Real ad -->
